import {
    all, put, PutEffect, select, SelectEffect, takeLatest, AllEffect, ForkEffect,
} from "redux-saga/effects";
import {
    history, Nullable, safeSaga, SET_AXIOS_ERROR, setAxiosError, SetAxiosErrorAction,
} from "@data-force/app";
import {EXTERNAL_EDITOR_URL_ERROR} from "@data-force/app/store/actions/availableActions";
import {SetExternalEditorUrlErrorAction} from "@data-force/app/interfaces/store/actions/editor";
import StoreState from "../../interfaces/store/storeState";
import HistoryParams from "../../interfaces/historyParams";
import {getHistoryParams} from "../../utils/common";
import {RoutesMap} from "../../interfaces/common";
import {Routes} from "../../utils/constants";
import {TabManager} from "../../utils/TabManager";

export function getBaseUrl(): SelectEffect {
    return select((state: StoreState): string => state.serviceProperties.fluxUrl);
}

export function getAnnotationUrl(): SelectEffect {
    return select((state: StoreState): string => state.serviceProperties.annotationEditorUrl);
}

export function getTranscriptionUrl(): SelectEffect {
    return select((state: StoreState): string => state.serviceProperties.transcriptionEditorUrl);
}

export function getEditorGatewayUrl(): SelectEffect {
    return select((state: StoreState): string => state.serviceProperties.editorGatewayUrl);
}

export function getActiveJobFilter(): SelectEffect {
    return select((state: StoreState): string => state.job.filter);
}

export function getJobTestType(): SelectEffect {
    return select((state: StoreState): Nullable<boolean> => state.job.isTest);
}

function* handleAxiosErrors({payload}: SetAxiosErrorAction): IterableIterator<PutEffect<SetAxiosErrorAction>> {
    if (payload) {
        const {UNAUTHORIZED, PAGE_NOT_FOUND}: RoutesMap = Routes;
        const historyParams: Nullable<HistoryParams> = getHistoryParams();

        switch (payload.response?.status) {
            case 403:
                history.push(`/${historyParams?.idpId}/${UNAUTHORIZED}`);
                break;
            case 404:
                history.push(`/${historyParams?.idpId}/${PAGE_NOT_FOUND}`);
                break;
            default:
                break;
        }

        yield put(setAxiosError(null));
    }
}

function* handleExternalEditorError({payload}: SetExternalEditorUrlErrorAction): IterableIterator<PutEffect<SetAxiosErrorAction>> {
    if (payload) {
        const {JOBS}: RoutesMap = Routes;
        const tabManager: TabManager = TabManager.getInstance();
        tabManager.closeTab();
        if ([403, 404].includes(payload)) {
            const historyParams: Nullable<HistoryParams> = getHistoryParams();
            history.push(`/${historyParams?.idpId}/${JOBS}`);
        }

        yield put(setAxiosError(null));
    }
}

export function* mainSagaActionWatcher(): IterableIterator<AllEffect<ForkEffect>> {
    yield all([
        takeLatest(SET_AXIOS_ERROR, safeSaga(handleAxiosErrors)),
        takeLatest(EXTERNAL_EDITOR_URL_ERROR, safeSaga(handleExternalEditorError)),
    ]);
}
